import React, {useEffect, useState} from 'react'
import styles from './skillBuilding.module.scss'

import API from 'Class/API'

import Button from 'Components/UI/Button'
import Error from 'Components/Feedback/Error'
import Item from 'Components/UI/Item'
import ScrollView from 'Components/UI/ScrollView'
import TextField from 'Components/UI/Field/TextField'

const Specializations = ({
    className = '',
    community = 0,
    label = 'Specializations',
    onChange = () => {},
    selected: selectedInput = []
}) => {
    const [error, setError] = useState(false)
    const [loading, setLoading] = useState(true)
    const [newSpecialization, setNewSpecialization] = useState('')
    const [selected, setSelected] = useState(selectedInput)
    const [specializations, setSpecializations] = useState([])

    const addSpecialization = async () =>
    {
        if (!newSpecialization)
        {
            return
        }
        setError(false)
        setLoading(true)
        const {id, message} = await API.RequestAsync('skillActivities/specialization-add', {community, name: newSpecialization})
        setLoading(false)
        if (!id)
        {
            setError(message)
        }
        else if (specializations.find(item => item.id === id))
        {
            setSelected([...selected, id])
            onChange([...selected, id])
            setNewSpecialization('')
        }
        else
        {
            const specialization = {id, name: newSpecialization}
            setSpecializations([...specializations, specialization])
            setSelected([...selected, id])
            onChange([...selected, id])
            setNewSpecialization('')
        }
    }

    const fetchSpecializations = async () =>
    {
        setError(false)
        setLoading(true)
        const {list, error, message} = await API.RequestAsync('skillActivities/specialization-list', {community})
        setLoading(false)
        if (!list || error)
        {
            setError(message || 'Failed to fetch specializations')
        }
        else
        {
            setSpecializations(list || [])
        }
    }

    const toggleSpecialization = (_, id) =>
    {
        const newSelected = selected.includes(id) ? selected.filter(item => item !== id) : [...selected, id]
        setSelected(newSelected)
        onChange(newSelected)
    }

    useEffect(() => {fetchSpecializations()}, [])
    useEffect(() => {setSelected(selectedInput)}, [JSON.stringify(selectedInput)])

    let content = null

    if (error)
    {
        content = <Error label={error}/>
    }
    else
    {
        content = specializations.map(({id, name}) => (
            <Item
                className={[styles.specializationItem, selected.includes(id) && styles.selected].join(' ')}
                id={id}
                key={id}
                label={name}
                onClick={toggleSpecialization}
                title={name}
            />
        ))
    }

    return (
        <div className={[styles.specializations, className].join(' ')}>
            {label && <div className={styles.specializationLabel}>{label}</div>}
            <div className={styles.specializationListWrapper}>
                <ScrollView>
                    <div className={styles.specializationList}>
                        {content}
                    </div>
                </ScrollView>
            </div>
            <div className={styles.addSpecialization}>
                <TextField
                    className={styles.addSpecializationInput}
                    value={newSpecialization}
                    onChange={(_, value) => setNewSpecialization(value)}
                    onInput={(_, value) => setNewSpecialization(value)}
                    onEnter={addSpecialization}
                    placeholder='New specialization...'
                />
                <Button
                    className={styles.addSpecializationButton}
                    disabled={loading || !newSpecialization}
                    label='Add new'
                    loading={loading}
                    onClick={addSpecialization}
                />
            </div>
        </div>
    )
}

export default Specializations